import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Single supabase client for the LockerBids teaser page.
 *
 * Uses the anon key — waitlist writes go through RLS policy defined in
 * migration 20260417100000_waitlist_submissions. RLS only permits INSERT,
 * never SELECT, so we never expose emails client-side.
 *
 * If env vars are missing (e.g. during a local dev spin without a .env.local),
 * the client is null and the waitlist form falls back to a polite error.
 */

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase: SupabaseClient | null =
  supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;

export const SOURCE_BRAND = 'lockerbids' as const;
